export default {
    stat: {
        class_hours: []
    }
}
